<template>
  <div>
    <!-- 自定义下拉 -->

    <div class="box">
      <div class="box_left">
        <div class="item" v-for="(item, index) in boxRef.left">
          <div class="select" @click.stop="itemClik(item.value, item, index)"
            :class="itemValue == item.value ? 'selectTrue' : ''">
            <div style="display: flex; justify-content: center">
              <div>
                {{ item.name }}
              </div>

              <div class="select_icon select_icon_" v-if="item.listShow"></div>
            </div>
          </div>
          <div class="select_box_" v-if="item.listShow">
            <div class="select_box">
              <div class="select_box_slect" :class="itemValue2 == item_.value ? 'selectboxTrue' : ''"
                v-for="(item_, index_) in item.list" @click.stop="
                  itemClik2(item.value, item_.value, item, item_, index, index_)
                  ">
                {{ item_.name }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="boxRef.center" style="
            width: 0.01rem;
            margin-top: 0.1rem;
            height: 0.21rem;
            opacity: 1;
            border: 0.01rem solid #e5e6eb;
            margin-left: 0.1rem;
            margin-right: 0.1rem;
          "></div>
        <div class="item" v-for="(item, index) in boxRef.center">
          <div class="select" @click="itemClik(item.value, item, index)"
            :class="itemValue == item.value ? 'selectTrue' : ''">
            <div style="display: flex; justify-content: center">
              <div>
                {{ item.name }}
              </div>

              <div class="select_icon select_icon_" v-if="item.listShow"></div>
            </div>
          </div>
          <div class="select_box_" v-if="item.listShow">
            <div class="select_box" :style="'width:' + item.width">
              <div class="select_box_slect" :style="item.width ? 'text-align:left' : ''"
                :class="itemValue2 == item_.value ? 'selectboxTrue' : ''" v-for="(item_, index_) in item.list"
                @click.stop="
                  itemClik2(item.value, item_.value, item, item_, index, index_)
                  ">
                {{ item_.name }}
              </div>

              <!-- 插槽的使用方式 -->
              <div v-if="item.value == '5'" style="margin-bottom: 10px">
                <div style="
                    display: flex;
                    padding: 0 0.08rem;
                    box-sizing: border-box;
                    margin-top: 0.08rem;
                  ">
                  <el-input style="width: 0.82rem" v-model="time1" type="number" placeholder="最小(元)" />
                  <span style="
                      margin: 0 0.04rem;
                      display: inline-block;
                      color: #86909c;
                      line-height: 23px;
                    ">—</span>
                  <el-input style="width: 0.82rem" v-model="time2" type="number" placeholder="最大(元)" />
                  <el-button style="margin-left: 0.08rem; color: #fff" color="#FF6000" @click="isDark">确定</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box_right">
        <div class="item" v-for="(item, index) in boxRef.right">
          <div class="select" @click.stop="itemClik(item.value, item, index)"
            :class="itemValue == item.value ? 'selectTrue' : ''">
            <div style="display: flex; justify-content: center">
              <div>
                {{ item.name }}
              </div>

              <div class="select_icon select_icon_" v-if="item.listShow"></div>
            </div>
          </div>
          <div class="select_box_" v-if="item.listShow">
            <div class="select_box">
              <div class="select_box_slect" :class="itemValue2 == item_.value ? 'selectboxTrue' : ''"
                v-for="(item_, index_) in item.list" @click.stop="
                  itemClik2(item.value, item_.value, item, item_, index, index_)
                  ">
                {{ item_.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  watchEffect,
  inject,
  provide,
  getCurrentInstance,
} from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

defineProps({
  boxRef: Object,
});
const itemValue = ref(11);
const itemValue2 = ref(null);
// const boxRef = ref()
const time1 = ref();
const time2 = ref();
const isDark = function () {
  instance?.emit("isDarkTime", time1.value, time2.value);
};
const instance = getCurrentInstance();
const itemClik = (value, item, index, index_) => {
  itemValue.value = value;
  console.log(value);
  instance?.emit("tabClick", value, item, "", "", index, index_);
};
const itemClik2 = (value, value2, item, item2, index, index_) => {
  itemValue.value = value;
  itemValue2.value = value2;
  instance?.emit("tabClick", value, value2, item, item2, index, index_);
  console.log(value);
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.select_icon {
  margin-left: 0.04rem;
  width: 0.14rem;
  height: 0.14rem;
  margin-top: 0.12rem;
  background: url(data:image/png;base64,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);
  background-size: 100% 100%;
}

.box_left,
.box_right,
.box_center {
  display: flex;

  .item {
    width: 1.12rem;
    height: 0.37rem;
    line-height: 0.37rem;
    opacity: 1;
    text-align: center;
    border: 1px solid #fff;
    cursor: pointer;
    border-radius: 0.08rem;
    box-sizing: border-box;
  }

  .select:hover,
  .selectTrue {
    border: 1px solid #C01A26;
    border-radius: 0.08rem;
    color: #C01A26;
    position: relative;

    .select_icon_ {
      background: url(data:image/png;base64,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);
      background-size: 100% 100%;
    }
  }

  .select_box {
    overflow: hidden;
    position: absolute;
    margin-top: 0.18rem;
    text-align: center;
    min-width: 1.12rem;
    z-index: 10;
    border-radius: 0.08rem;
    background: #fff;
    padding: 0.04rem;
    box-sizing: border-box;
    display: none;
    box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(32, 40, 58, 0.25);
    max-height: 4rem;
    overflow-y: auto;

    .select_box_slect:hover,
    .selectboxTrue {
      background: #f0f1f1;
      color: #333333;
      cursor: pointer;
    }

    .item {
      width: 1.12rem;
      height: 0.37rem;
      line-height: 0.37rem;
      opacity: 1;
      text-align: center;
      border: 1px solid transparent;
      cursor: pointer;
      border-radius: 0.08rem;
      box-sizing: border-box;
    }

    .select_box_slect:hover,
    .selectboxTrue {
      background: #f0f1f1;
      color: #333333;
      cursor: pointer;
    }

    .select_box_slect {
      padding: 0 0.08rem;
      box-sizing: border-box;
    }
  }

  .item:hover {
    .select_box {
      display: block;

      .select_icon {
        display: block;
      }
    }

    .select_icon_ {
      background: url(data:image/png;base64,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);
      background-size: 100% 100%;
    }
  }

  .select_box_ {
    min-width: 1.12rem;
    margin-top: -0.1rem;
    display: block;
    position: absolute;
    height: 0.5rem;
    background: transparent;
    z-index: 11;
    // background: red
  }

  .select_box_:hover {
    display: block;

    .select_box {
      display: block;
    }

    .select_icon_ {
      background: url(data:image/png;base64,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);
      background-size: 100% 100%;
    }
  }
}

/deep/ .el-button {
  background: #C01A26;
  border: 1px solid #C01A26;
}
</style>
